import ko from '@tko/build.knockout';
import _ from 'lodash';
import BaseDialog from '../../../../components/modal-dialog/base-dialog';
import DialogVM from './add-panel.vm';
import templateMarkup from 'raw-loader!./add-panel.template.html';
    

    var instance = null;

    function PanelOptionsModal() {
        if (instance !== null) {
            throw new Error('Cannot instantiate more than one PanelOptionsModal. Call PanelOptionsModal.getInstance() instead!');
        }
    }

    PanelOptionsModal.prototype = {
        showModal: function(config) {
            return BaseDialog.showModal({
                viewModel: new DialogVM(config),
                template: templateMarkup,
                context: this
            });
        }
    };

    PanelOptionsModal.getInstance = function() {
        if (instance === null) {
            instance = new PanelOptionsModal();
        }
        return instance;
    };

    export default PanelOptionsModal.getInstance();

